const DEFAULT_INPUT_CURRENCY = '48cfWPgvT9KnX3e9MzXMpww2T473JmbRiudFympzYftJ'

const LEADERBOARD_PATH = '/leaderboard'
const RULES_PATH = '/rules'

export { DEFAULT_INPUT_CURRENCY, LEADERBOARD_PATH, RULES_PATH }
